import {Injectable} from '@angular/core';
import {AosOrderInterface, KeystringValueInterface, ToolInterface} from '../../models/sharedinterface';
import {HttpClient} from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {

  private appConfigs;

  private bffapiroot = 'https://api-dev.media4.ch/api2/portal';

  private languages: {};

  private defaultlanguagekey: string;

  private simorigin: string;

  private portalFieldTypeFormlyFieldTypeMap: {};

  constructor(private http: HttpClient) {

    this.languages = {
      en: {key: 'en', value: 'English'} as KeystringValueInterface,
      fr: {key: 'fr', value: 'Français'} as KeystringValueInterface,
      de: {key: 'de', value: 'Deutsch'} as KeystringValueInterface
    };

    this.defaultlanguagekey = 'en';

    this.simorigin = 'https://aos.longines.com';

    this.portalFieldTypeFormlyFieldTypeMap = {
      text: {type: 'input', defaultValue: ''},
      checkbox: {type: 'checkbox', defaultValue: false},
      textarea: {type: 'textarea', defaultValue: ''},
      password: {type: 'input', defaultValue: '', addedTemplateOptions: {type: 'password'}},
    };

  }

  loadAppConfig() {
    return this.http
      .get('assets/conf/config.json')
      .toPromise()
      .then(data => {
        this.appConfigs = data;
      });
  }

  getBffapiroot() {
    if (this.appConfigs.hasOwnProperty('bffapiroot')) {
      return this.appConfigs.bffapiroot;
    } // if
    return '';
  } // getBffapiroot

  getBCapiroot() {
    if (this.appConfigs.hasOwnProperty('bcapiroot')) {
      return this.appConfigs.bcapiroot;
    } // if
    return '';
  } // getBffapiroot

  getCredentialSeparator() {
    if (this.appConfigs.hasOwnProperty('credentialseparator')) {
      return this.appConfigs.credentialseparator;
    } // if
    return '|-|||-|';
  } // getCredentialSeparator

  getLanguage(key: string) {
    if (this.languages.hasOwnProperty(key)) {
      return this.languages[key];
    } else {
      return {key: '', value: ''} as KeystringValueInterface;
    } // if
  } // getLanguage

  getDefaultLanguagekey() {
    return this.defaultlanguagekey;
  } // getDefaultLanguagekey


  isAmongRoles(specificroles: string[] = [], userroles: string[] = []) {
    // The user roles comes from shared data
    // This component subscribes for any user roles change
    if (userroles.length === 0 || specificroles.length === 0) {
      return false;
    } // if

    // Find intersection
    for (const item of specificroles) {
      if (userroles.indexOf(item) !== -1) {
        return true;
      } // if
    } // for
    return false;
  } // isAmongRoles


  getSimorigin(): string {

    const origin = window.location.origin;

    const simorigindict = {
      'https://aos.longines.com': 'https://aos.longines.com',
      'https://hermes.media4.ch': 'https://hermes.media4.ch',
      'https://omega.media4.ch': 'https://omega.media4.ch',
      'https://zenith.media4.ch': 'https://zenith.media4.ch',
      'https://parmigiani.media4.ch': 'https://parmigiani.media4.ch',
      'https://gfms.media4.ch': 'https://gfms.media4.ch',

      'https://longines-dev2.media4.ch': 'https://aos.longines.com',
      'https://hermes-dev2.media4.ch': 'https://hermes.media4.ch',
      'https://omega-dev2.media4.ch': 'https://omega.media4.ch',
      'https://zenith-dev2.media4.ch': 'https://zenith.media4.ch',
      'https://parmigiani-dev2.media4.ch': 'https://parmigiani.media4.ch',
      'https://gfms-dev2.media4.ch': 'https://gfms.media4.ch',

      'http://localhost:4200': 'https://aos.longines.com',
      'http://localhost:4000': 'https://aos.longines.com',
      'http://localhost:5000': 'https://hermes.media4.ch',
      'http://localhost:6500': 'https://omega.media4.ch',
      'http://localhost:7000': 'https://zenith.media4.ch',
      'http://localhost:8000': 'https://parmigiani.media4.ch',
      'http://localhost:8500': 'https://gfms.media4.ch',

      'https://longines-prod-calitho.localdev.ch': 'https://aos.longines.com',
      'https://hermes-prod-calitho.localdev.ch': 'https://hermes.media4.ch',
      'https://omega-prod-calitho.localdev.ch': 'https://omega.media4.ch',
      'https://zenith-prod-calitho.localdev.ch': 'https://zenith.media4.ch',
      'https://parmigiani-prod-calitho.localdev.ch': 'https://parmigiani.media4.ch',
      'https://gfms-prod-calitho.localdev.ch': 'https://gfms.media4.ch',

      'https://longines-rc.media4.ch': 'https://aos.longines.com',
      'https://hermes-rc.media4.ch': 'https://hermes.media4.ch',
      'https://omega-rc.media4.ch': 'https://omega.media4.ch',
      'https://zenith-rc.media4.ch': 'https://zenith.media4.ch',
      'https://parmigiani-rc.media4.ch': 'https://parmigiani.media4.ch',
      'https://gfms-rc.media4.ch': 'https://gfms.media4.ch',

    };

    return simorigindict[origin];
  }

  getAosHost() {
    return 'https://aos2.media4.ch';
  } // getAosHost

  getOwsEntryPoints() {
    return {
      'https://ows.media4.ch/display': '',
      'https://dev-ows.media4.ch/display': ''
    };
  } // getOwsEntryPoints

  getCampaignviewerEntryPoints() {
    return {
      'https://tools.media4.ch/cv/longines': '',
      'https://tools.media4.ch/cv_dev/longines': '',
      'https://cv.media4.ch/longines': '',
      'https://cv-rc.media4.ch/longines': '',
      'https://cv-dev.media4.ch/longines': '',
    };
  } // getCampaignviewerEntryPoints

  getInstoreEntryPoints() {
    return {
      'https://is.media4.ch/market': '',
      'https://dev-is.media4.ch/market': ''
    };
  } // getInstoreEntryPoints

  getToolPathStructureWithQuery() {
    return ':languagekey/ext/:toolid/:toolkey/:params';
  } // getToolPathStructureWithQuery

  getToolPathStructure() {
    return ':languagekey/ext/:toolid/:toolkey';
  } // getToolPathStructure

  getHelpPathStructure() {
    return ':languagekey/help';
  } // getHelpPathStructure

  mapPortalToFormlyFieldType(typename: string) {
    if (this.portalFieldTypeFormlyFieldTypeMap.hasOwnProperty(typename)) {
      return this.portalFieldTypeFormlyFieldTypeMap[typename];
    } // if
    return '';
  }


  stringReplace(input: string, search: string, replacement: string) {
    const regex = new RegExp(search, 'gi');  // equivalent to regex = "/search/gi";
    // For const regex = /\|/gi, use search = "\\|"
    return input.replace(regex, replacement);
  } // stringReplace

  transformFlatJsonKeyFromSeparatorToPoint(flatjson: {}) {
    const transformedJson = {};
    // available in IE also (object.keys)
    Object.keys(flatjson).forEach(key => {
      const newKey = this.stringReplace(key, '\\|', '.');
      transformedJson[newKey] = flatjson[key];
    });
    return transformedJson;
  } // transformFlatJsonKeyFromSeparatorToPoint

  transformFlatJsonKeyFromPointToSeparator(flatjson: {}) {
    const transformedJson = {};
    // available in IE also (object.keys)
    Object.keys(flatjson).forEach(key => {
      const newKey = this.stringReplace(key, '\\.', '|');
      transformedJson[newKey] = flatjson[key];
    });
    return transformedJson;
  } // transformFlatJsonKeyFromSeparatorToPoint

  // Return /ext/<toolid>/<toolkeyword> style path
  getPortalToolUrl(languagekey: string, toolid: number, toolkeyword: string) {
    return '/' + languagekey + '/ext/' + toolid + '/' + toolkeyword;
  } // getPortalToolPath

  getPortalToolPath(languagekey: string, toolid: number, toolkeyword: string) {
    return [this.getPortalToolUrl(languagekey, toolid, toolkeyword)];
  } // getPortalToolPath


  getAosProdRenewPath(language: KeystringValueInterface, tools: ToolInterface[], order: AosOrderInterface) {
    if (!language || tools.length === 0) {
      return ['/'];
    } // if

    for (const tool of tools) {

      if (tool.toolclassname === 'aos' && tool.toolenvname === 'prod') {

        // alwpkey=V2Order&a=drawAssetSelect&oid=103729&mode=reload
        // Important: simple cotes are mandantory in params build to avoid %3 at the end of the encoding b64 phase.
        const params = '&alwpkey=V2Order&a=drawAssetSelect&oid=' + order.id + '&mode=reload';
        const utf8Params = CryptoJS.enc.Utf8.parse(params);
        const encryptedParams = CryptoJS.enc.Base64.stringify(utf8Params);

        return [this.getPortalToolUrl(language.key, tool.toolid, tool.toolkeyword) + '/' + encryptedParams];

      } // if

    } // for

    // No aos tools -> redirect to home
    return ['/'];

  } // getAosProdPath


  convertDateFormatFromDb(date, destinationformat = 'YYYY-MM-DD') {
    const utc = moment.utc(date).toDate();
    const local = moment(utc).local().format(destinationformat);
    return local;
  } // convertDateFormatFromDb

}
